import React from 'react';
import { timeAgo } from '@/utils/ts/stringUtils';

import ButtonComponent from '../ButtonComponent/ButtonComponent';

export default function ReachoutLimitNotification({
  notification,
  setShowLitePlanModal,
  setShowNotificationDropdown,
  markSingleNotificationAsSeen,
}) {
  return (
    <div className={`single-notification ${notification.seen && 'seen'}`}>
      <div className="unread-dot"></div>
      <div className="avatar-div" style={{ width: '30px' }}>
        ⚠️
      </div>
      <div className="text-div" style={{ marginLeft: 6 }}>
        <h3 className="title">{notification?.title}</h3>
        <div className="mt-2">
          <ButtonComponent
            variant="primary-outline"
            style={{ padding: '4px 8px' }}
            textStyle={{ fontSize: '14px' }}
            onClick={() => {
              setShowLitePlanModal('reachouts');
              setShowNotificationDropdown(null);
              markSingleNotificationAsSeen();
            }}>
            What&apos;s This?
          </ButtonComponent>
        </div>
        <p className="timestamp" style={{ paddingTop: 8 }}>
          {timeAgo(notification?.createdAt)}
        </p>
      </div>
    </div>
  );
}
